<template>
    <div class="modal fade" id="manual-booking-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>{{transEdit('book-manually')}}</h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                    <input type="hidden" id="manual-booking-modal-schedule-id">
                </div>

                <div class="modal-body">
                    <h4>{{transEdit('date-and-time')}}:</h4>
                    <h5><b><span id="manual-booking-modal-date"></span>, </b>
                    <span id="manual-booking-modal-time"></span></h5>

                    <div class="form-check">
                        <label class="form-check-label">
                            <input class="form-check-input" type="checkbox" value=""
                               id="manual-booking-modal-anonymous-booking"
                               v-model="anonymousUser">
                            {{transEdit('book-as-anonymous')}}
                        </label>
                    </div>
                    <br>

                    <div>
                        <input type="text" class="form-control user-autocomplete"
                               title="Sök användare" placeholder="Användarnamn" id="user-autocomplete"/>
                        <input type="hidden" id="user-id">
                    </div>
                    <div id="manual-booking-modal-missing-user">
                        <br>
                        <h5>Du måste ange en användare</h5>
                    </div>
                    <br>

                    <div class="form-select">
                        <select class="form-control" id="manual-booking-modal-treatments">
                        </select>
                    </div>
                    <br>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary"
                            v-on:click="bookUser"><i class="fa fa-plus"></i> {{transEdit('book')}}</button>

                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "therapist-dash-modal-manual-booking",
        props: ['route_manual_booking', 'date'],
        data: function () {
            return {
                anonymousUser: false,
            }
        },
        watch: {
            anonymousUser: function (value) {
                //$("#manual-booking-modal-missing-user").hide();
            }
        },
        methods: {
            bookUser: function () {
                let self = this;
                let thisModal = $("#manual-booking-modal");
                let data = {};

                let shouldBookAnonymously = false;
                //data.anonymousBooking = shouldBookAnonymously;
                data.anonymousBooking = false;
                data.date = this.date;
                let userId = $("#user-id").val();

                data.treatmentId = $("#manual-booking-modal-treatments").val();
                data.scheduleId = $("#manual-booking-modal-schedule-id").val();

                let performManualBooking = false;

                if (!shouldBookAnonymously && userId) {
                    data.userId = userId;
                    performManualBooking = true;
                } else if (shouldBookAnonymously) {
                    performManualBooking = true;

                } else {
                    $("#manual-booking-modal-missing-user").show();
                }

                if (performManualBooking) {

                    axios.post(this.$portalUrl(this.route_manual_booking), data)
                    .then(function (result) {
                        self.$emit('close');
                    })
                    .catch(function (error) {
                    });

                    thisModal.modal('toggle');
                }
            }
        }
    }
</script>

<style scoped>


</style>
